(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3477],{

/***/ 1602:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/changelog",
      function () {
        return __webpack_require__(2384);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _components_templates_ReleaseNotesTemplate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8553);
// import node_modules




// import component

// define page
var ReleaseNotesPage = function(param) {
    var hrefLang = param.hrefLang, releaseNotes = param.releaseNotes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_ReleaseNotesTemplate__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        hrefLang: hrefLang,
        releaseNotes: releaseNotes
    });
};
ReleaseNotesPage.propTypes = {
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    releaseNotes: prop_types__WEBPACK_IMPORTED_MODULE_4__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4__.shape({
        app: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_2__/* .ReleaseNoteAppTypeEnum */ .W)).isRequired,
        category: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_2__/* .ReleaseNoteCategoryEnum */ .uX)).isRequired,
        content: prop_types__WEBPACK_IMPORTED_MODULE_4__.shape({
            compiledSource: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
        }).isRequired,
        ctaLink: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
        ctaText: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
        pubDate: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
        title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
        type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
    }).isRequired).isRequired
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ReleaseNotesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,675,6880,5128,8553,9774,2888,179], function() { return __webpack_exec__(1602); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);